import { render } from "./HealthDataEvolutionDrawer.vue?vue&type=template&id=a4ac2d52&scoped=true"
import script from "./HealthDataEvolutionDrawer.vue?vue&type=script&lang=js"
export * from "./HealthDataEvolutionDrawer.vue?vue&type=script&lang=js"

import "./HealthDataEvolutionDrawer.vue?vue&type=style&index=0&id=a4ac2d52&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ac2d52"]])

export default __exports__